import _ from 'underscore';
import {
  bulkApiErrorNumberToErrorCodeMapping,
  bulkApiErrorNumberToErrorFormatMapping,
  bulkApiErrorNumberToErrorMessageMapping,
  bulkApiErrorPropertyMapping,
  errorMappingWithSubScenario,
} from './error-mapping';
import {
  CampaignEditorialError,
  CampaignApiError,
} from './error-types';
import {
  getCampaignApiErrorProperty,
  getCampaignApiErrorMessageWithErrorCode,
  getCampaignApiErrorFormatWithErrorCode,
} from './get-odata-api-error';
import {
  getEditorialErrorMessage
} from './get-editorial-error';

export function getBulkApiErrorProperty(property) {
  return (property && bulkApiErrorPropertyMapping[property]) || property;
}

export function getErrorMappingWithSubScenario(error, scenario) {
  const apiError = (error && errorMappingWithSubScenario[error]) || '';

  return _.propertyOf(apiError)(scenario);
}

export function getBulkApiErrorCodeWithErrorNumber(errorNumber) {
  const i18nKey = `API_ErrorNumber_${errorNumber}`;

  return bulkApiErrorNumberToErrorCodeMapping[i18nKey];
}

function getBulkApiErrorMessageWithErrorCode(errorCode, errorNumber, i18n) {
  const errorMessage = bulkApiErrorNumberToErrorMessageMapping[errorNumber];

  const message = (errorCode && getCampaignApiErrorMessageWithErrorCode(errorCode, i18n)) ||
    (errorMessage && i18n.getString(errorMessage));
  const format = errorCode ?
    getCampaignApiErrorFormatWithErrorCode(errorCode) :
    bulkApiErrorNumberToErrorFormatMapping[errorNumber];

  return { message, format };
}

// Bulk Error
export const getBulkApiErrors = (errs, scenario, i18n, activityLogger) => _.map(errs, ({
  Type,
  Property,
  EditorialCode,
  EditorialLocation,
  Error,
  ErrorNumber,
}) => {
  let message;
  let Ctor;
  let property = Property;
  let isHtmlMessage = false;

  if (EditorialCode) {
    message = getEditorialErrorMessage(EditorialCode, i18n, activityLogger);

    if (_.isEmpty(Property) && !_.isEmpty(EditorialLocation)) {
      property = EditorialLocation;
    }

    Ctor = CampaignEditorialError;
  } else {
    const mtErrorCode = getErrorMappingWithSubScenario(Error, scenario)
      || getBulkApiErrorCodeWithErrorNumber(ErrorNumber);

    if (_.isEmpty(Property) && !_.isEmpty(Error)) {
      property = getCampaignApiErrorProperty(Error);
    }

    const messageInfo = getBulkApiErrorMessageWithErrorCode(mtErrorCode, `API_ErrorNumber_${ErrorNumber}`, i18n);
    message = messageInfo.message || Error;
    ({ format: { isHtmlMessage = false } = {} } = messageInfo);

    Ctor = CampaignApiError;
  }

  property = getBulkApiErrorProperty(property);

  const error = new Ctor(message, property, EditorialCode || Error);
  error.type = Type;
  error.isHtmlMessage = isHtmlMessage;
  return error;
});

// Get Partial Error
export const mapErrors = (entity, errors, scenario, i18n, activityLogger) => {
  if (entity && errors) {
    const entityErrors = _.filter(errors, { 'Client Id': entity['Client Id'] });

    if (!_.isEmpty(entityErrors)) {
      // eslint-disable-next-line no-param-reassign
      entity.errors = getBulkApiErrors(entityErrors, scenario, i18n, activityLogger);
    }
  }
};

export const getPartial = (response, processItems, scenario, i18n, activityLogger) => {
  if (!_.isEmpty(response) && !_.isEmpty(response.entity) && !_.isEmpty(response.errors)) {
    const { entity, errors } = response;

    mapErrors(entity, errors, scenario, i18n, activityLogger);

    _.each(processItems, (item) => {
      if (_.isArray(entity[item])) {
        _.each(entity[item], (subEntity) => {
          mapErrors(subEntity, errors, scenario, i18n, activityLogger);
        });
      } else {
        mapErrors(entity[item], errors, scenario, i18n, activityLogger);
      }
    });
  }
};
